import { Card } from "@/components/Card";
import { Tooltip } from "@/components/Tooltip";
import { P, H2 } from "@/components/Typography";
import { getCurrencySymbol } from "@/utils/helpers";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IProps {
  icon: IconProp;
  title: string;
  value: string;
  tooltip: string;
  isPercent?: boolean;
  isCurrency?: boolean;
  currency?: string;
}

const EmailDashboardCard = ({
  icon,
  title,
  value,
  tooltip,
  isPercent = false,
  isCurrency = false,
  currency = "USD",
}: IProps) => {
  const currencySymbol = getCurrencySymbol(currency);

  return (
    <div data-testid="email-dashboard-card">
      <Card shadow additionalClassName="py-20 px-10 border border-gray-light">
        <div className="mb-20 flex items-center gap-10">
          <div className="flex h-30 w-30 items-center justify-center rounded-full bg-primary-light p-5">
            <FontAwesomeIcon icon={icon} className="text-primary" />
          </div>
          <P className="font-medium">{title}</P>
          <Tooltip content={tooltip} maxWidth="md">
            <FontAwesomeIcon className="text-gray-400" icon={faInfoCircle} />
          </Tooltip>
        </div>

        <div className="flex flex-col items-center">
          <H2 className="font-bold">
            {isCurrency && currencySymbol}
            {value}
            {isPercent && "%"}
          </H2>
        </div>
      </Card>
    </div>
  );
};

export default EmailDashboardCard;
